import Vue from 'vue'
import App from './App.vue'
import VueMatomo from 'vue-matomo'
import router from './router'
import '@/assets/scss/normalize.scss'
import VueCompositionAPI from '@vue/composition-api'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '@/assets/css/swiper.min.css'

Vue.use(VueCompositionAPI)
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

Vue.use(VueMatomo, {
  host: 'https://103.135.32.98:8080',
  siteId: 13,
  router,
  enableLinkTracking: true
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
